export const DOCUMENTATION_URL = 'https://api.jenmusic.ai/';
